import React from "react";
import { Trans } from "@lingui/macro";
import { Link } from "react-router-dom";
import { ROUTS } from "../../../routs/routs";
import { ViewComponent } from "./ViewComponent";
import { CONTACTS } from "../../../constants/contacts";

export const NotFoundPage: React.FC = () => {
  const urlLinkSupport: string = `mailto:${CONTACTS.SUPPORT_EMAIL}`;
  const urlLinkHomePage: string = ROUTS.HOME_PAGE;

  return (
    <ViewComponent
      title={<Trans>404: Page Not Found</Trans>}
      message={
        <Trans values={{ urlLinkSupport, urlLinkHomePage }}>
          Sorry, but we cannot find a page for this url.
          <br />
          Please contact{" "}
          <a
            href={urlLinkSupport}
            className="font-medium text-indigo-600 hover:text-indigo-500"
          >
            support
          </a>{" "}
          or try again from the{" "}
          <Link
            to={urlLinkHomePage}
            className="font-medium text-indigo-600 hover:text-indigo-500"
          >
            Home page
          </Link>
          .
        </Trans>
      }
    />
  );
};
